module.exports = __webpack_public_path__ + "static/media/29DUNON8.971f2301.jpg";